<template>
  <div>
    <div>
      <div>
        <!-- /End replace -->
      </div>
      <div class="container">
        <div
          class="row justify-content-center mt-3"
          style="text-align: center;"
        >
          <div class="col-md-12 mt-4">
            <h3>Current Member Count</h3>
            <div class="text-center my-2" v-if="checkClockinLoading">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
            <div v-else>
              <b-button
                variant="danger"
                @click.prevent="minusClick"
                class="mr-3"
                ><i class="fas fa-minus text-grey" aria-hidden="true"></i
              ></b-button>
              <span class="pt-2" style="font-size: 30px;">{{
                getCurrentMemberCount
              }}</span>
              <b-button variant="success" @click.prevent="addClick" class="ml-3"
                ><i class="fas fa-plus text-grey" aria-hidden="true"></i
              ></b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "Dashboard",
  components: {},
  data() {
    return {
      name: "",
      isClockin: false,
      clockinLoading: false,
      checkClockinLoading: true,
      clockinTime: null,
      hasMessage: false,
      showMessage: null,
      currentMemberCount: 0,
    };
  },
  mounted() {
    this.getCntMember();
  },
  created() {},
  computed: {
    ...mapState({
      user: "user",
    }),
    getCurrentMemberCount() {
      return this.currentMemberCount;
    },
  },
  methods: {
    logout() {
      axios.post("/logout").then((response) => {
        localStorage.removeItem("isLoggedIn");
        this.$router.push({ name: "Home" });
      });
    },
    async minusClick() {
      //this.currentMemberCount--;
      this.checkClockinLoading = true;
      await axios.get("/api/memcntdown").then((response) => {
        //console.log(response.data);
        this.getCntMember();
        this.checkClockinLoading = false;
      });
    },
    async getCntMember() {
      let self = this;
      this.checkClockinLoading = true;
      await axios
        .get(`/api/getcurrentoccupants`)
        .then((response) => {
          //console.log(response.data);
          if (response.data != null) {
            var num = response.data;
            //console.log(num);
            self.currentMemberCount = num;
          }
        })
        .catch(function(error) {})
        .finally(() => {
          this.checkClockinLoading = false;
        });
    },
    async addClick() {
      //this.currentMemberCount++;

      this.checkClockinLoading = true;
      await axios.get("/api/memcntup").then((response) => {
        //console.log(response.data);
        this.getCntMember();
        this.checkClockinLoading = false;
      });
    },
  },
};
</script>
